import React, { Fragment } from 'react'

import { Helmet } from 'react-helmet'

import Navigation from '../components/navigation'
import Pricing8 from '../components/pricing8'
import Footer from '../components/footer'
import './pricing1.css'

const Pricing1 = (props) => {
  return (
    <div className="pricing1-container">
      <Helmet>
        <title>Pricing1 - California Places</title>
        <meta property="og:title" content="Pricing1 - California Places" />
        <link
          rel="canonical"
          href="https://copy-of-glass-outstanding-chamois-m7jub6.teleporthq.app/pricing"
        />
        <meta
          property="og:url"
          content="https://copy-of-glass-outstanding-chamois-m7jub6.teleporthq.app/pricing"
        />
      </Helmet>
      <Navigation
        button={
          <Fragment>
            <span className="pricing1-text10">Contact Us</span>
          </Fragment>
        }
        button1={
          <Fragment>
            <span className="pricing1-text11">Pricing</span>
          </Fragment>
        }
        rootClassName="navigationroot-class-name5"
      ></Navigation>
      <Pricing8
        plan2={
          <Fragment>
            <span className="pricing1-text12">Monthly Plan</span>
          </Fragment>
        }
        plan21={
          <Fragment>
            <span className="pricing1-text13">Annual Plan</span>
          </Fragment>
        }
        heading1={
          <Fragment>
            <span className="pricing1-text14">
              Download To Activate Free Trial - No Signup Required
            </span>
          </Fragment>
        }
        plan2Price={
          <Fragment>
            <span className="pricing1-text15">$11.99/mo</span>
          </Fragment>
        }
        plan2Price1={
          <Fragment>
            <span className="pricing1-text16">$120/year</span>
          </Fragment>
        }
        plan2Yearly1={
          <Fragment>
            <span className="pricing1-text17">or $10 monthly</span>
          </Fragment>
        }
        plan2Feature1={
          <Fragment>
            <span className="pricing1-text18">
              Deep insight for a low price
            </span>
          </Fragment>
        }
        plan2Feature2={
          <Fragment>
            <span className="pricing1-text19">Know before you move</span>
          </Fragment>
        }
        plan2Feature3={
          <Fragment>
            <span className="pricing1-text20">Instant Answers</span>
          </Fragment>
        }
        plan2Feature4={
          <Fragment>
            <span className="pricing1-text21">
              Robust reports - impress clients.
            </span>
          </Fragment>
        }
        rootClassName="pricing8root-class-name"
        plan2Feature11={
          <Fragment>
            <span className="pricing1-text22">
              Deep insight for a low price
            </span>
          </Fragment>
        }
        plan2Feature21={
          <Fragment>
            <span className="pricing1-text23">Know before you move.</span>
          </Fragment>
        }
        plan2Feature31={
          <Fragment>
            <span className="pricing1-text24">Instant Answers</span>
          </Fragment>
        }
        plan2Feature41={
          <Fragment>
            <span className="pricing1-text25">
              Robust reports - Impress Clients
            </span>
          </Fragment>
        }
      ></Pricing8>
      <Footer></Footer>
    </div>
  )
}

export default Pricing1
